import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { AwareHttpService } from '@appbolaget/aware-http';
import { AwareHttpRequestModule } from '@appbolaget/aware-http';
import { AwareHttpRequest } from '@appbolaget/aware-http';
import { Unit, Bucket, File } from '@appbolaget/aware-model';
import { Store } from '@ngxs/store';
import { UnitState } from 'app/state/unit.state';
import { saveAs } from 'file-saver';
import { FilesystemResponse } from './components';

@Injectable()
export class MediaService {
    refresh$: Subject<void> = new Subject();

    unit: Unit;
    activeLibraryMode: 'unit' | 'client';
    activeLibraryClient: string;

    private store = inject(Store);
    constructor(private api: AwareHttpService) {}

    changeTitle(item: File | (Bucket & { alt: string })) {
        return this.api
            .put(item instanceof File ? 'files' : 'buckets', { title: item.title, alt: item.alt }, item.uuid)
            .module(AwareHttpRequestModule.Media)
            .execute();
    }

    deleteItems(items: Array<File | Bucket>) {
        const batch = {
            requests: [],
        };

        for (const item of items) {
            let route = `files/${item.uuid}`;

            if (item instanceof Bucket) {
                route = `buckets/${item.uuid}`;
            }

            batch.requests.push({
                name: 'item',
                method: 'DELETE',
                route: route,
            });
        }

        return this.api
            .batch(batch)
            .unit(this.unit ? this.unit.uuid : this.store.selectSnapshot(UnitState.activeUnit).uuid)
            .module(AwareHttpRequestModule.Media)
            .execute();
    }

    async downloadFile(file: File) {
        const blob = await firstValueFrom(
            this.api.get(`@media/${file.getFilePath()}`).responseType('blob').module(AwareHttpRequestModule.Media).execute(),
        );

        return saveAs(blob, file.title);
    }

    getBucketsAndFiles(
        bucket: any = null,
        sorting: any,
        mode: 'client' | 'unit',
        page: number,
        searchTerm?: string,
        unit = this.unit,
    ): Observable<FilesystemResponse> {
        const params: any = { mode, bucket, with_files: 'attributes,meta', q: searchTerm };

        if (this.activeLibraryClient) {
            params.client_id = this.activeLibraryClient;
        }

        let request = this.api
            .get(searchTerm ? 'filesystem/search' : 'filesystem')
            .module(AwareHttpRequestModule.Media)
            .parameters(params)
            .limit(25)
            .page(page)
            .unit(unit?.uuid);

        if (!searchTerm) {
            request = request.sort(sorting.value, sorting.order);
        }

        return request.execute().pipe(
            map((result: any) => {
                let { buckets, files } = result.data;

                buckets = buckets.map((i) => new Bucket(i));
                files = files.map((i) => new File(i));

                return {
                    buckets,
                    files,
                    pagination: result.pagination,
                };
            }),
        );
    }

    moveFile(item: File | Bucket, parentUuid: string): AwareHttpRequest {
        return this.api
            .put(
                item instanceof File ? 'files' : 'buckets',
                item instanceof File ? { bucket_id: parentUuid || null } : { parent_id: parentUuid || null },
                item.uuid,
            )
            .module(AwareHttpRequestModule.Media);
    }

    save(item: File | Bucket) {
        if (item instanceof File) {
            return this.saveFile(new File(item));
        }

        return this.saveBucket(new Bucket(item));
    }

    saveBucket(bucket: Bucket, unit = this.unit): Observable<Bucket> {
        // const method = bucket.uuid ? 'put' : 'post';
        // const url = bucket.uuid ? `buckets/${bucket.uuid}` : 'buckets';

        if (!unit) {
            bucket.private = true;
        }

        let request = bucket.save(this.api, { fields: ['title', 'private'] }).module(AwareHttpRequestModule.Media);
        if (unit) {
            request = request.unit(unit.uuid);
        }

        return request.toModel(Bucket).execute();

        // const request = (<AwareHttpRequest>this.api[method](url, serializeAwareModel(bucket))).module(AwareHttpRequestModule.Media);

        // if (unit) {
        //     request.unit(unit.uuid);
        // }

        // return request.execute();
    }

    saveFile(file: File) {
        // const method = file.uuid ? 'put' : 'post';
        // const url = file.uuid ? `files/${file.uuid}` : 'files';

        // const params = this.activeLibraryClient ? { client_id: this.activeLibraryClient } : null;

        return file
            .save(this.api, { fields: ['title', 'alt', 'public'] })
            .module(AwareHttpRequestModule.Media)
            .unit(this.unit ? this.unit.uuid : this.store.selectSnapshot(UnitState.activeUnit).uuid)
            .execute();
        // return (
        //     (<AwareHttpRequest>this.api[method](url, serializeAwareModel(file)))
        //         .module(AwareHttpRequestModule.Media)
        //         // .parameters(params)
        //         .unit(this.unit ? this.unit.uuid : this.store.selectSnapshot(UnitState.activeUnit).uuid)
        //         .execute()
        // );
    }
}
